import { lzKebabToWordCase, lzSingularize } from "../../services/LzStrings";
import LzCrudModelField from "./field";
import LzCrudModelInput from "./input";
import LzCrudModelListCol from "./list-column";
import LzCrudModelListActionIcon from "./list-action-icon";
import LzCrudModelListGroupActionIcon from "./list-group-action-icon";

/**
 * LzCrudModel class
 */
export default class LzCrudModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        if (model instanceof LzCrudModel) {
            Object.assign(this, model);
            return;
        }

        this.ident = model.ident ? model.ident : '';
        this.baseRoute = model.baseRoute ? model.baseRoute : '/' + this.ident;
        this.labels = model.labels ? model.labels : lzKebabToWordCase(this.ident);
        this.label = model.label ? model.label : lzSingularize(this.labels);
        this.isTreeBased = !!model.isTreeBased;
        this.treeNodeLabel = model.treeNodeLabel ? model.treeNodeLabel : (item) => item.name || '';
        this.parentName = model.parentName ? model.parentName : (item) => item.name || '';
        this.maxDepth = model.maxDepth ? +model.maxDepth : 0;
        this.fields = LzCrudModelField.parseData(model.fields);
        this.listingColumns = LzCrudModelListCol.parseData(model.listingColumns, this.fields);
        this.addFormInputs = LzCrudModelInput.parseData(model.addFormInputs, this.fields);
        this.viewFormFields = LzCrudModelInput.parseData(model.viewFormFields, this.fields, true);
        this.editFormInputs = LzCrudModelInput.parseData(model.editFormInputs, this.fields);
        this.showExport = !!model.showExport;
        this.showImport = !!model.showImport;
        this.showAdd = typeof model.showAdd !== 'undefined' ? model.showAdd : true;
        this.showTreeAdd = typeof model.showTreeAdd !== 'undefined' ? model.showTreeAdd : true;
        this.showView = typeof model.showView !== 'undefined' ? model.showView : true;
        this.showEdit = typeof model.showEdit !== 'undefined' ? model.showEdit : true;
        this.showStatus = typeof model.showStatus !== 'undefined' ? model.showStatus : !!this.fields.is_active;
        this.showDelete = typeof model.showDelete !== 'undefined' ? model.showDelete : true;
        this.showDeletedList = typeof model.showDeletedList !== 'undefined' ? model.showDeletedList : true;
        this.allowDeletedRestore = typeof model.allowDeletedRestore !== 'undefined' ? model.allowDeletedRestore : this.showDeletedList;
        this.allowDeletedPurge = typeof model.allowDeletedPurge !== 'undefined' ? model.allowDeletedPurge : this.showDeletedList;
        this.listingActionIcons = LzCrudModelListActionIcon.parseData(model.listingActionIcons, this);
        this.noGroupActions = !!model.noGroupActions;
        this.showStatusGroupAction = typeof model.showStatusGroupAction !== 'undefined' ? model.showStatusGroupAction : this.showStatus;
        this.showDeleteGroupAction = typeof model.showDeleteGroupAction !== 'undefined' ? model.showDeleteGroupAction : this.showDelete;
        this.listingGroupActionIcons = LzCrudModelListGroupActionIcon.parseData(model.listingGroupActionIcons, this);
    }

    get hasGroupActions() {
        return !this.noGroupActions && Object.keys(this.listingGroupActionIcons).length > 0;
    }
}
